import { MediaType } from '../../media/types'
import type { StatusChar } from '../../search/types'

export const MEDIA_TYPE_LOOKUP: Record<MediaType, string> = {
  [MediaType.Document]: 'Document',
  [MediaType.Image]: 'Image',
  [MediaType.Video]: 'Video',
}

export const STATUS_LOOKUP: Record<StatusChar, string> = {
  C: 'Current',
  N: 'Non-Current',
}

export const PCE_PAX_IDS = new Set(['PCE', 'PAX'])
